/* eslint-disable no-undef */
/* /src/utils/authConst.js */
import { getSiteOrigin, getSiteUrl } from "./siteUrl";

const authority = process.env.REACT_APP_AUTHORITY;
const clientId = process.env.REACT_APP_CLIENT_ID;
const siteOrigin = getSiteOrigin();

export const IDENTITY_CONFIG = {

    // "authority": "https://auth.jerelia.com",
    authority, //(string): The URL of the OIDC provider.
    "client_id": clientId,
    "redirect_uri": getSiteUrl("/callback"),
    "popup_redirect_uri": getSiteUrl("/callback"),
    "post_logout_redirect_uri": siteOrigin,
    "silent_redirect_uri": getSiteUrl("/silentrenew"),
    "response_type": process.env.REACT_APP_RESPONSE_TYPE,
    "scope": process.env.REACT_APP_SCOPE,
    "automaticSilentRenew": true,
    "monitorSession": true,
    "loadUserInfo": true

    
    // client_id: process.env.REACT_APP_CLIENT_ID, //(string): Your client application's identifier as registered with the OIDC provider.
    // redirect_uri: process.env.REACT_APP_REDIRECT_URL, //The URI of your client application to receive a response from the OIDC provider.
    // login: process.env.REACT_APP_AUTHORITY + "login",
    // automaticSilentRenew: true, //(boolean, default: false): Flag to indicate if there should be an automatic attempt to renew the access token prior to its expiration.
    // loadUserInfo: true, //(boolean, default: true): Flag to control if additional identity data is loaded from the user info endpoint in order to populate the user's profile.
    // silent_redirect_uri: process.env.REACT_APP_REDIRECT_URL, //(string): The URL for the page containing the code handling the silent renew.
    // post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URL, // (string): The OIDC post-logout redirect URI.
    // audience: "https://jerelia.com", //is there a way to specific the audience when making the jwt
    // responseType: process.env.REACT_APP_RESPONSE_TYPE, //(string, default: 'id_token'): The type of response desired from the OIDC provider.
    // grantType: "password",
    // scope: "api1 openid roles email jerelia_identity_admin_api profile", //(string, default: 'openid'): The scope being requested from the OIDC provider.
    // webAuthResponseType: process.env.REACT_APP_RESPONSE_TYPE
};


export const METADATA_OIDC = {
    issuer: authority,
    jwks_uri: authority + "/.well-known/openid-configuration/jwks",
    authorization_endpoint: authority + "/connect/authorize",
    token_endpoint: authority + "/connect/token",
    userinfo_endpoint: authority + "/connect/userinfo",
    end_session_endpoint: authority + "/connect/endsession",
    check_session_iframe: authority + "/connect/checksession",
    revocation_endpoint: authority + "/connect/revocation",
    introspection_endpoint: authority + "/connect/introspect"
};
